import { Injectable } from "@angular/core";
import { Http, Response, Headers, RequestOptions, ResponseContentType } from "@angular/http";
import { CookieService } from "ngx-cookie-service";
import { Observable } from "rxjs/Observable";
import { AppCommonService } from "../appcommon.service";
import { AuthService } from "../auth.service";
import { GlobalService } from "../global.service";
import { Router } from "@angular/router";
import { ApiEndPoints } from "../api.endpoints";
import { forEach } from "@angular/router/src/utils/collection";
import { ICards, IDrawingAccounts, IDrawings, CardTranLiveCardModel, CardTranDrawingPointModel, CardTranDrawingModel, CO2Model, ICO2, DrawingsDataTablesResponse, AcceptedResponse } from "./cardtransaction"
import { IAccount } from '../headerandnavigation/accounts/account';
import { LoaderService } from "../LoaderService";

@Injectable()
export class CardTransactionService extends GlobalService {

  constructor(
    private http: Http,
    private cookieService: CookieService,
    private appCommonService: AppCommonService,
    private authService: AuthService,
    public loaderService: LoaderService,
    private router: Router
  ) {
    super(http, router);
    this.authServiceRef = this.authService;
  }


  //getCardsList(): Observable<ICards[]> {        
  //    let cards = <IAccount[]>JSON.parse(localStorage.getItem("mftAccessAccounts"));
  //    let headers = this.authService.GetAuthHeader();
  //    let options = new RequestOptions({ headers: headers });

  //    const url = ApiEndPoints.CardsEndPoint.replace('{accountNumber}', cards.filter(x => x.selected == true)[0].name);
  //    return this.http.get(url, options)
  //        .map(data => <ICards[]>data.json())
  //        .catch(this.handleError);
  //}

    getCardsList(model: CardTranLiveCardModel): Observable<ICards[]> {
        //debugger;
    let body = JSON.stringify(model);
    let callURL = ApiEndPoints.BaseURL + ApiEndPoints.GetCardTranLiveCards;
    //let headers: Headers = new Headers({
    //  'Content-Type': 'application/json; charset=utf-8'
    //});
    let options = new RequestOptions({ headers: this.authService.GetHeader() });
    return this.http.post(callURL, body, options)
      .map((response: Response) => <any>response.json())
      .catch(this.handleError);
  }

  //getDrawingPointList() {

  //    let cards = <IAccount[]>JSON.parse(localStorage.getItem("mftAccessAccounts"));
  //    let headers = this.authService.GetAuthHeader();

  //    let options = new RequestOptions({ headers: headers });
  //    const url = ApiEndPoints.DrawingPointEndPoint.replace('{accountId}', cards.filter(x => x.selected == true)[0].id);
  //    return this.http.get(url, options)
  //        .map(data => <IDrawingAccounts[]>data.json())
  //        .catch(this.handleError);
  //}

    getDrawingPointList(model: CardTranDrawingPointModel): Observable<IDrawingAccounts[]> {
        //debugger;
    let body = JSON.stringify(model);
    let callURL = ApiEndPoints.BaseURL + ApiEndPoints.GetCardTranDrawingPoints;
    //let headers: Headers = new Headers({
    //  'Content-Type': 'application/json; charset=utf-8'
    //});
    let options = new RequestOptions({ headers: this.authService.GetHeader() });
    return this.http.post(callURL, body, options)
      .map((response: Response) => <any>response.json())
      .catch(this.handleError);
  }


  //getDrawings(queryString) {
  //    let cards = <IAccount[]>JSON.parse(localStorage.getItem("mftAccessAccounts"));
  //    let headers = this.authService.GetAuthHeader();

  //    let options = new RequestOptions({ headers: headers });
  //    let url = ApiEndPoints.DrawingEndPoint.replace('{accountId}', cards.filter(x => x.selected == true)[0].id);
  //    debugger
  //    url = url + queryString;
  //    return this.http.get(url, options)
  //        .map(data => <IDrawings[]>data.json())
  //        .catch(this.handleError);
  //}

  getDrawings(model: CardTranDrawingModel): Observable<IDrawings[]> {
    let body = JSON.stringify(model);
    let callURL = ApiEndPoints.BaseURL + ApiEndPoints.GetCardTranDrawings;
    //let headers: Headers = new Headers({
    //  'Content-Type': 'application/json; charset=utf-8'
    //});
    let options = new RequestOptions({ headers: this.authService.GetHeader() });
    return this.http.post(callURL, body, options)
      .map((response: Response) => <any>response.json())
      .catch(this.handleError);
  }

  getDrawingsNew(model: CardTranDrawingModel): Observable<AcceptedResponse> {
    let body = JSON.stringify(model);
    let callURL = ApiEndPoints.BaseURL + ApiEndPoints.GetCardTranDrawingsNew;
    //let headers: Headers = new Headers({
    //  'Content-Type': 'application/json; charset=utf-8'
    //});
    let options = new RequestOptions({ headers: this.authService.GetHeader() });
    return this.http.post(callURL, body, options)
      .map((response: Response) => <any>response.json())
      .catch(this.handleError);
  }

  prePareCardTransDocument(refNumber: string, type: string, sort: string, co2: string): Observable<AcceptedResponse> {
    let callURL = ApiEndPoints.BaseURL + ApiEndPoints.PrePareCardTransEndPoint;
    callURL = callURL.replace("{id}", refNumber).replace("{type}", type).replace("{sort}", sort).replace("{co2}", co2);
    //let headers: Headers = new Headers({
    //  'Content-Type': 'application/json; charset=utf-8'
    //});
    let options = new RequestOptions({ headers: this.authService.GetHeader() });
    return this.http.get(callURL, options)
      .map((response: Response) => <any>response.json())
      .catch(this.handleError);
  }


  UnScubscribeCardTransactionMemory(userId: string): Observable<null> {
    let callURL = ApiEndPoints.BaseURL + ApiEndPoints.CardTransactionMemoryLeak;
    callURL = callURL.replace("{userId}", userId);
    //let headers: Headers = new Headers({
    //  'Content-Type': 'application/json; charset=utf-8'
    //});
    let options = new RequestOptions({ headers: this.authService.GetHeader() });
    return this.http.get(callURL, options)
      .map((response: Response) => <any>response.json())
      .catch(this.handleError);
  }

  getCardTransDocument(refNumber: string, type: string) {

    let callURL = ApiEndPoints.BaseURL + ApiEndPoints.DownloadCardTransEndPoint;
    callURL = callURL.replace("{id}", refNumber).replace("{type}", type);
    //let headers: Headers = new Headers({
    //  'Content-Type': 'application/x-www-form-urlencoded;'
    //});
    return this.http
      .get(callURL, {
        responseType: ResponseContentType.Blob, headers: this.authService.GetHeaderDocument()
      })
      .map(res => {
        const contentDisposition = res.headers.get('content-disposition') || '';
        const matches = /filename=([^;]+)/ig.exec(contentDisposition);
        const fileName = (matches[1] || 'untitled').trim();
        return {
          filename: fileName,
          data: res.blob()
        };
      })
      .subscribe(res => {
        if (navigator.appVersion.toString().indexOf('.NET') > 0 || navigator.msSaveBlob) {
          window.navigator.msSaveBlob(res.data, res.filename);
          this.loaderService.display(false);
        }
        else {
          var url = window.URL.createObjectURL(res.data);
          var a = document.createElement('a');
          document.body.appendChild(a);
          a.setAttribute('style', 'display: none');
          a.href = url;
          a.download = res.filename;
          a.click();
          window.URL.revokeObjectURL(url);
          a.remove(); // remove the element
          this.loaderService.display(false);
        }
      }, error => {
        this.loaderService.display(false);
        alert('download error:' + JSON.stringify(error));
        //console.log('download error:', JSON.stringify(error));
      }, () => {
        //console.log('Completed file download.')
      });
  }

  checkDrawingStatus(location: any): Observable<AcceptedResponse> {
    let callURL = location;
    //let headers: Headers = new Headers({
    //  'Content-Type': 'application/json; charset=utf-8'
    //});
    callURL = callURL + "?key=" + this.authService.getToken().access_token;
    let options = new RequestOptions({ headers: this.authService.GetHeader() });
    return this.http.get(callURL, options)
      .map((response: Response) => <any>response.json())
      .catch(this.handleError);
  }

  getCO2Counts(model: CO2Model): Observable<ICO2[]> {
    let body = JSON.stringify(model);
    let callURL = ApiEndPoints.BaseURL + ApiEndPoints.GetCO2Counts;
    //let headers: Headers = new Headers({
    //  'Content-Type': 'application/json; charset=utf-8'
    //});
    let options = new RequestOptions({ headers: this.authService.GetHeader() });
    return this.http.post(callURL, body, options)
      .map((response: Response) => <any>response.json())
      .catch(this.handleError);
  }

}





// WEBPACK FOOTER //
// ./src/app/cardtransaction/cardtransaction.service.ts